<template>
  <div>
    <b-loading v-model="loading" />

    <div class="level">
      <div class="level-left">
        <div class="level-item">
          <div>
            <p class="title">Links for {{serviceData.title}}</p>
            <p class="heading">{{serviceData.code}}</p>
          </div>
        </div>
      </div>
    </div>

    <div class="box" v-for="(link, i) in paymentLinks" :key="`link-${i}`">
      <link-editor :link="link"
                   @urlInput="(e) => updateLink('url', e, i)"
                   @ctaInput="(e) => updateLink('cta', e, i)"
                   @couponInput="(e) => updateLink('coupon', e, i)"
                   @priceInput="(e) => updateLink('price', e, i)"
                   @cbfidInput="(e) => updateLink('cbfid', e, i)"
                   @processorInput="(e) => updateLink('processor', e, i)"
                   @removeLink="() => removePayLink(link)" />
    </div>

    <div class="box">
      <b-field v-if="!showLinkForm">
        <div class="control is-expanded">
          <b-tag @close="showLinkForm = true"
                 closable
                 attached
                 close-icon="plus-circle"
                 close-icon-type="is-success"
                 type="is-success is-light"
                 size="is-medium">
            <span>Add Pay Link</span>
          </b-tag>
        </div>
        <div class="control">
          <button class="button is-success" @click="savePayLinks">Save</button>
        </div>
      </b-field>

      <b-field v-else grouped>
        <b-input  v-model="newLinkURL" placeholder="URL" /> <!--size="is-small"-->
        <b-input ref="ctaRef" v-model="newLinkCTA" placeholder="CTA" />
        <b-button type="is-success" @click="addPayLink">Add</b-button>
        <b-button type="is-text" @click="showLinkForm = false">
          <b-icon icon="close" />
        </b-button>
      </b-field>
    </div>
  </div>
</template>

<script>
import LinkEditor from '@/components/admin/LinkEditor';
import {logout, updateService} from '@/utils/api';

export default {
  components: {
    LinkEditor
  },
  data() {
    return {
      serviceData: {},
      paymentLinks: [],
      newLinkCTA: '',
      newLinkURL: '',
      showLinkForm: false,
      loading: false,
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    init: function () {
      let storedService = JSON.parse(localStorage.getItem('service'));
      let currentService = this.$route.params.service;

      if (storedService && storedService.code === currentService) {
        this.serviceData = storedService;
        this.paymentLinks = storedService.paymentLinks;
      }
    },
    updateLink: function (key, val, position) {
      this.paymentLinks[position][key] = val;
    },
    removePayLink: function (link) {
      let {cta, url} = link;
      let {paymentLinks} = this;
      this.paymentLinks = paymentLinks.filter(oldLink => oldLink.cta !== cta || oldLink.url !== url);

      this.savePayLinks();
    },
    addPayLink: function () {
      let { newLinkCTA, newLinkURL, paymentLinks } = this;

      this.paymentLinks = [...paymentLinks, {cta: newLinkCTA, url: newLinkURL}];
      this.newLinkCTA = '';
      this.newLinkURL = '';
      this.showLinkForm = false;
    },
    savePayLinks: function () {
      let { paymentLinks, serviceData } = this;
      let { code } = serviceData;

      this.paymentLinks = [...paymentLinks];
      this.loading = true;

      updateService({id: code, edits: {paymentLinks}})
      .then(async res => {
        if (!res.ok) {
          this.$buefy.toast.open({
            duration: 1000,
            message: `ERROR: ${res.status} ${res.statusText}`,
            type: 'is-danger'
          })

          console.log(await res.text());
          await logout({isAdmin: true});
          return this.$router.push('/login')
        }
        this.$buefy.toast.open({
          duration: 700,
          type: 'is-success',
          message: 'Updated!'
        });
      })
      .finally(() => this.loading = false);
    },
  }
}
</script>